


export const calculateCenter = (
  point1: { lat: number; lng: number },
  point2: { lat: number; lng: number }
): { lat: number; lng: number } => {
  return {
    lat: (point1.lat + point2.lat) / 2,
    lng: (point1.lng + point2.lng) / 2,
  };
};


export const calculateBounds = (
  points: Array<{ lat: number; lng: number }>
): { north: number; south: number; east: number; west: number } | null => {
  if (points.length === 0) {
    return null;
  }

  let north = points[0].lat;
  let south = points[0].lat;
  let east = points[0].lng;
  let west = points[0].lng;

  points.forEach((point) => {
    if (point.lat > north) north = point.lat;
    if (point.lat < south) south = point.lat;
    if (point.lng > east) east = point.lng;
    if (point.lng < west) west = point.lng;
  });

  return { north, south, east, west };
};


export const boundsCenter = (bounds: {
  north: number;
  south: number;
  east: number;
  west: number;
}): { lat: number; lng: number } => {
  return {
    lat: (bounds.north + bounds.south) / 2,
    lng: (bounds.east + bounds.west) / 2,
  };
};


export const estimateZoom = (bounds: {
  north: number;
  south: number;
  east: number;
  west: number;
}): number => {
  const latDiff = bounds.north - bounds.south;
  const lngDiff = bounds.east - bounds.west;
  const maxDiff = Math.max(latDiff, lngDiff);

  if (maxDiff > 0.1) return 10;
  if (maxDiff > 0.05) return 11;
  if (maxDiff > 0.02) return 12;
  if (maxDiff > 0.01) return 13;
  if (maxDiff > 0.005) return 14;
  return 15;
};


